import { Component } from '@angular/core';
import { StepperItem } from '../../components/stepper-item/stepper-item';
import { BaseTemplate } from '../../templates/base-template/base-template';
import { ConnectionCode } from '../../components/connection-code/connection-code';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-connection',
  imports: [StepperItem, BaseTemplate, ConnectionCode, TranslateModule],
  templateUrl: './connection-page.html',
  styleUrl: './connection-page.scss',
})
export class ConnectionPage { }
